import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import {
    showAuth,
    checkUser,
    flushUser,
    getDetails,
} from '../store/actions/Auth';
import { getData } from '../store/actions/Data';
import Logo from '../assests/logo-w.png';
import { auth } from '../firebase/index';

const MainMenu = () => {
    const dispatch = useDispatch();
    const authenticated = useSelector((state) => state.auth.authenticated);

    useEffect(() => {
        if (!authenticated) {
            auth.onAuthStateChanged((user) => {
                dispatch(getData());
                if (user !== null) {
                    dispatch(checkUser(user));
                    dispatch(getDetails(user.uid));
                }
            });
        }
    }, [authenticated, dispatch]);

    useEffect(() => {
        if (authenticated) {
            dispatch(getData());
        }
    }, [authenticated, dispatch]);

    const handleSignOut = () => {
        auth
            .signOut()
            .then(() => {
                dispatch(flushUser());
            })
            .catch((error) => {
                console.log(error);
            });
    };

    // Inline styles to match your current project exactly
    const headerStyle = {
        backgroundColor: "#395578",
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
        width: "100%",
        position: "relative"
    };

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)"
    };

    const logoContainerStyle = {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "0px 16px"
    };

    const logoStyle = {
        width: "auto",
        maxHeight: "100%",
        maxWidth: "160px",
        filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
        transition: "transform 0.2s ease",
        cursor: "pointer"
    };

    const titleContainerStyle = {
        padding: "16px 0",
        margin: "5px 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: 1
    };

    const titleStyle = {
        lineHeight: "1.2",
        color: "white",
        margin: "0 5px",
        textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
        letterSpacing: "-0.025em",
        fontWeight: "600",
        textAlign: "center",
		fontSize: "24px"
    };

    const navContainerStyle = {
        display: "flex",
        alignItems: "center",
        gap: "16px",
        padding: "0px 24px"
    };

    const navLinkStyle = {
        padding: "8px 16px",
        borderRadius: "8px",
        transition: "all 0.2s ease",
        fontWeight: "400",
        color: "rgba(255, 255, 255, 0.9)",
        textDecoration: "none",
        cursor: "pointer",
        border: "none",
        background: "none"
    };

    const activeLinkStyle = {
        ...navLinkStyle,
        color: "white",
        fontWeight: "400",
        backgroundColor: "rgba(255, 255, 255, 0.2)"
    };

    const signOutButtonStyle = {
        ...navLinkStyle,
        color: "rgba(255, 255, 255, 0.8)"
    };

    const mobileNavStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        padding: "12px 20px 16px",
        borderTop: "1px solid rgba(255, 255, 255, 0.15)",
        background: "rgba(0, 0, 0, 0.1)",
		fontSize: "12px"
    };

    const mobileNavContainerStyle = {
        display: "flex",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap",
        justifyContent: "center"
    };

    if (authenticated) {
        return (
            <header style={headerStyle}>
                <div style={containerStyle}>
                    <div style={logoContainerStyle}>
                        <img 
                            src={Logo} 
                            alt="Logo" 
                            style={logoStyle}
                            onMouseEnter={(e) => e.target.style.transform = "scale(1.05)"}
                            onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                        />
                    </div>
                    <div style={titleContainerStyle}>
                        <h1 style={titleStyle} className="font-montserrat">
                            Sistema de Monitoreo de Eventos de Sobredosis
                        </h1>
                    </div>
                    <div style={navContainerStyle} className="font-montserrat desktop-nav">
                        <a 
                            href="/dashboardnew/" 
                            style={navLinkStyle}
                            onMouseEnter={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "white";
                                    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "rgba(255, 255, 255, 0.9)";
                                    e.target.style.backgroundColor = "transparent";
                                }
                            }}
                        >
                            Dashboard
                        </a>
                        <a 
                            href="/dashboardnew/service-providers" 
                            style={navLinkStyle}
                            onMouseEnter={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "white";
                                    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "rgba(255, 255, 255, 0.9)";
                                    e.target.style.backgroundColor = "transparent";
                                }
                            }}
                        >
                            Servicios
                        </a>
                        
                    
                        <NavLink 
                            to="/evento" 
                            style={navLinkStyle}
                            activeStyle={activeLinkStyle}
                            onMouseEnter={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "white";
                                    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "rgba(255, 255, 255, 0.9)";
                                    e.target.style.backgroundColor = "transparent";
                                }
                            }}
                        >
                            Evento
                        </NavLink>
                        <NavLink 
                            to="/archivo" 
                            style={navLinkStyle}
                            activeStyle={activeLinkStyle}
                            onMouseEnter={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "white";
                                    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "rgba(255, 255, 255, 0.9)";
                                    e.target.style.backgroundColor = "transparent";
                                }
                            }}
                        >
                            Archivo
                        </NavLink>
                        <NavLink 
                            to="/duplicados" 
                            style={navLinkStyle}
                            activeStyle={activeLinkStyle}
                            onMouseEnter={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "white";
                                    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "rgba(255, 255, 255, 0.9)";
                                    e.target.style.backgroundColor = "transparent";
                                }
                            }}
                        >
                            Duplicados
                        </NavLink>
                        <NavLink 
                            to="/perfil" 
                            style={navLinkStyle}
                            activeStyle={activeLinkStyle}
                            onMouseEnter={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "white";
                                    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!e.target.classList.contains('active')) {
                                    e.target.style.color = "rgba(255, 255, 255, 0.9)";
                                    e.target.style.backgroundColor = "transparent";
                                }
                            }}
                        >
                            Perfil
                        </NavLink>
                        <button 
                            onClick={handleSignOut}
                            style={signOutButtonStyle}
                            className="font-montserrat"
                            onMouseEnter={(e) => {
                                e.target.style.color = "white";
                                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.color = "rgba(255, 255, 255, 0.8)";
                                e.target.style.backgroundColor = "transparent";
                            }}
                        >
                            Sign Out
                        </button>
                    </div>
                </div>

                <div style={mobileNavStyle} className="mobile-nav">
                    <div style={mobileNavContainerStyle} className="font-montserrat">
                        <a 
                            href="/dashboardnew/" 
                            style={navLinkStyle}
                        >
                            Dashboard
                        </a>
                        <a 
                            href="/dashboardnew/service-providers" 
                            style={navLinkStyle}
                        >
                            Servicios
                        </a>
                        
                     
                        <NavLink 
                            to="/evento" 
                            style={navLinkStyle}
                            activeStyle={activeLinkStyle}
                        >
                            Evento
                        </NavLink>
                        <NavLink 
                            to="/archivo" 
                            style={navLinkStyle}
                            activeStyle={activeLinkStyle}
                        >
                            Archivo
                        </NavLink>
                        <NavLink 
                            to="/duplicados" 
                            style={navLinkStyle}
                            activeStyle={activeLinkStyle}
                        >
                            Duplicados
                        </NavLink>
                        <NavLink 
                            to="/perfil" 
                            style={navLinkStyle}
                            activeStyle={activeLinkStyle}
                        >
                            Perfil
                        </NavLink>
                        <button 
                            onClick={handleSignOut}
                            style={{ ...signOutButtonStyle, color: "rgba(255, 255, 255, 0.8)" }}
                            className="font-montserrat"
                        >
                            Sign Out
                        </button>
                    </div>
                </div>
            </header>
        );
    }

    return (
        <header style={headerStyle}>
            <div style={containerStyle}>
                <div style={logoContainerStyle}>
                    <img 
                        src={Logo} 
                        alt="Agency Logo" 
                        style={logoStyle}
                        onMouseEnter={(e) => e.target.style.transform = "scale(1.05)"}
                        onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                    />
                </div>
                <div style={titleContainerStyle}>
                    <h1 style={titleStyle} className="font-montserrat">
                        Sistema de Monitoreo de Eventos de Sobredosis
                    </h1>
                </div>
                <div style={navContainerStyle} className="font-montserrat desktop-nav">
                    <a 
                        href="/dashboardnew/" 
                        style={navLinkStyle}
                        onMouseEnter={(e) => {
                            if (!e.target.classList.contains('active')) {
                                e.target.style.color = "white";
                                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!e.target.classList.contains('active')) {
                                e.target.style.color = "rgba(255, 255, 255, 0.9)";
                                e.target.style.backgroundColor = "transparent";
                            }
                        }}
                    >
                        Dashboard
                    </a>
                    <a 
                        href="/dashboardnew/service-providers" 
                        style={navLinkStyle}
                        onMouseEnter={(e) => {
                            if (!e.target.classList.contains('active')) {
                                e.target.style.color = "white";
                                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!e.target.classList.contains('active')) {
                                e.target.style.color = "rgba(255, 255, 255, 0.9)";
                                e.target.style.backgroundColor = "transparent";
                            }
                        }}
                    >
                        Servicios
                    </a>
                    
                    
                    <NavLink 
                        to="/evento" 
                        style={navLinkStyle}
                        activeStyle={activeLinkStyle}
                        onMouseEnter={(e) => {
                            if (!e.target.classList.contains('active')) {
                                e.target.style.color = "white";
                                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!e.target.classList.contains('active')) {
                                e.target.style.color = "rgba(255, 255, 255, 0.9)";
                                e.target.style.backgroundColor = "transparent";
                            }
                        }}
                    >
                        Evento
                    </NavLink>
                    <button 
                        onClick={() => dispatch(showAuth())}
                        style={signOutButtonStyle}
                        className="font-montserrat"
                        onMouseEnter={(e) => {
                            e.target.style.color = "white";
                            e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.color = "rgba(255, 255, 255, 0.8)";
                            e.target.style.backgroundColor = "transparent";
                        }}
                    >
                        Sign In
                    </button>
                </div>
            </div>

            <div style={mobileNavStyle} className="mobile-nav">
                <div style={mobileNavContainerStyle} className="font-montserrat">
                    <a 
                        href="/dashboardnew/" 
                        style={navLinkStyle}
                    >
                        Dashboard
                    </a>
                    <a 
                        href="/dashboardnew/service-providers" 
                        style={navLinkStyle}
                    >
                        Servicios
                    </a>
                    
                    
                    <NavLink 
                        to="/evento" 
                        style={navLinkStyle}
                        activeStyle={activeLinkStyle}
                    >
                        Evento
                    </NavLink>
                    <button 
                        onClick={() => dispatch(showAuth())}
                        style={{ ...signOutButtonStyle, color: "rgba(255, 255, 255, 0.8)" }}
                        className="font-montserrat"
                    >
                        Sign In
                    </button>
                </div>
            </div>
        </header>
    );
};

export default MainMenu;